import { useFormikContext } from 'formik';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AddArticleRequestFormArticleSelectorProps } from './types';
import { Row } from 'components/base/Row';
import Select from 'components/base/Select';
import { OrderLine } from 'config/apiFunus/generated/data-contracts';
import { useArticles } from 'hooks/useArticles';
import { MasterDataWithPrice } from 'hooks/useArticles/MasterDataWithPrice';

export const AddArticleRequestFormArticleSelector: FC<
  AddArticleRequestFormArticleSelectorProps
> = ({ category, disabled, onArticleChange }) => {
  const { t } = useTranslation();

  const {
    values, errors, setValues,
  } = useFormikContext<OrderLine & {
        articleDescription?: string;
        supplierDescription?: string;
        idSupplier?: string;
        isCalendarOpen?: boolean;
        isProviderOpen?: boolean;
      }>();

  const {
    fetchArticleByCategory,
    articlesByCategory,
  } = useArticles();

  useEffect(
    () => {
      if (category) {
        fetchArticleByCategory(category)
          .catch(() => false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [category],
  );

  return (
    <Select<MasterDataWithPrice>
      key="code"
      disabled={disabled}
      error={errors.code}
      getLabel={({ description, priceWithVAT }) => {
        let label = '';
        if (description) {
          label = `${description}`;
        }
        if (priceWithVAT) {
          label = `${label} (${priceWithVAT}€)`;
        }

        return label;
      }}
      getValue={({ code }) => code || ''}
      itemContent={({ description, priceWithVAT }) => (
        <Row justifyContent="space-between" style={{ width: '100%' }}>
          <div style={{ textAlign: 'left' }}>{description}</div>
          <div style={{ textAlign: 'right' }}>
            (
            {priceWithVAT}
            €)
          </div>
        </Row>
      )}
      name="code"
      options={articlesByCategory}
      placeholder={t('common.articles')}
      value={articlesByCategory.find((article) => article.code === values.code)}
      searchable
      onChange={(article) => {
        setValues({
          ...values,
          articleDescription: article?.description,
          code: article?.code,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          price: (article?.price as any),
        });
        onArticleChange?.(article?.description || '');
      }}
    />
  );
};
